import APIClient from '@/shared/http/clients/api'

const APIBusinessCommon = process.env.APIBaseURLBusinessCommon
const resourceName = 'MidiaDespesaDiversos'

const GetByDespesaDiversosId = (id, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetByDespesaId/${id}`, config)
const Base64ByArquivoId = (arquivoId, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/DownloadZpagConprovante/${arquivoId}`, data, config)

const TravelExpenseRepository = {
  GetByDespesaDiversosId,
  Base64ByArquivoId
}

export default TravelExpenseRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/midiamiscellaneous.js